import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { ResponsiveTable } from '../components/ResponsiveTable';
import { api } from '../utils/api';
import { Search, TrendingDown } from 'lucide-react';
import { toast } from 'sonner';
import { useWebSocketContext } from '../context/WebSocketContext';

export const Exits = () => {
  const [movements, setMovements] = useState([]);
  const [products, setProducts] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const { subscribe } = useWebSocketContext();

  const fetchData = React.useCallback(async () => {
    try {
      const [movementsRes, productsRes] = await Promise.all([
        api.getMovements(),
        api.getProducts()
      ]);
      
      const exits = movementsRes.data.filter(m => m.type === 'exit');
      setMovements(exits);
      
      const productsMap = {};
      productsRes.data.forEach(p => {
        productsMap[p.id] = p;
      });
      setProducts(productsMap);
    } catch (error) {
      toast.error('Error al cargar datos');
    }
  }, []);

  // Carga inicial
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // POLLING DESACTIVADO - causaba recargas visuales y pérdida de foco
  // useEffect(() => {
  //   const pollingInterval = setInterval(() => {
  //     fetchData();
  //   }, 5000);
  //   return () => clearInterval(pollingInterval);
  // }, [fetchData]);

  // Subscribe to WebSocket updates (instantáneo)
  useEffect(() => {
    const unsubscribe = subscribe((message) => {
      if (message.type === 'stock_update' && message.movement?.type === 'exit') {
        console.log('📤 Exits: Nueva salida WebSocket', message);
        fetchData(); // Ahora funcionará correctamente
        toast.success('Nueva salida registrada', { duration: 2000 });
      }
    });

    return unsubscribe;
  }, [subscribe, fetchData]);

  const filteredMovements = movements.filter(m => {
    const product = products[m.product_id];
    return product && (
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.barcode.includes(searchTerm)
    );
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tight flex items-center gap-3">
          <TrendingDown className="h-10 w-10" style={{ color: '#FF5F00' }} />
          Salidas
        </h1>
        <p className="text-base text-slate-600 dark:text-slate-300 mt-2">Historial de salidas de stock</p>
      </div>

      <Card className="border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        <CardHeader>
          <div className="flex items-center gap-2">
            <Search className="h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Buscar por producto..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="max-w-sm rounded-sm"
              data-testid="search-exits-input"
            />
          </div>
        </CardHeader>
        <CardContent>
          <ResponsiveTable
            data={filteredMovements.map(movement => ({
              ...movement,
              product: products[movement.product_id]
            }))}
            columns={[
              {
                key: 'created_at',
                label: 'Fecha',
                className: 'uppercase tracking-wider text-xs',
                render: (item) => (
                  <span className="font-mono text-sm">
                    {new Date(item.created_at).toLocaleString('es-ES', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                )
              },
              {
                key: 'product',
                label: 'Producto',
                className: 'uppercase tracking-wider text-xs',
                render: (item) => (
                  <div>
                    <p className="font-medium">{item.product?.name || 'Producto no encontrado'}</p>
                    <p className="text-sm text-slate-500 dark:text-slate-400 font-mono">{item.product?.barcode}</p>
                  </div>
                )
              },
              {
                key: 'quantity',
                label: 'Cantidad',
                className: 'uppercase tracking-wider text-xs',
                render: (item) => (
                  <span className="font-mono font-bold text-orange-600 dark:text-orange-400">
                    -{item.quantity}
                  </span>
                )
              },
              {
                key: 'notes',
                label: 'Notas',
                className: 'uppercase tracking-wider text-xs',
                render: (item) => (
                  <span className="text-sm text-slate-500 dark:text-slate-400">
                    {item.notes || '-'}
                  </span>
                )
              }
            ]}
            emptyMessage="No se encontraron salidas"
          />
        </CardContent>
      </Card>
    </div>
  );
};